import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=15b9d4e0&scoped=true"
import script from "./Inputs.vue?vue&type=script&lang=ts"
export * from "./Inputs.vue?vue&type=script&lang=ts"
import style0 from "./Inputs.vue?vue&type=style&index=0&id=15b9d4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b9d4e0",
  null
  
)

export default component.exports